export default function CtaBand() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="overflow-hidden rounded-lg bg-accent-500 px-6 py-10 md:px-12 md:py-14">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                挑一部剧，现在就开始追
              </h2>
              <p className="mt-3 text-sm leading-7 text-foreground-900">
                先按类型锁定片单，再根据自己的时间选择网页版入口或手机在线看。
                想了解更新节奏与追剧技巧，也可以继续往下浏览相关分区。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row">
              <a
                href="#hot"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-900"
              >
                <i className="ri-play-fill"></i>
                挑选剧目
              </a>
              <a
                href="#schedule"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/30 bg-transparent px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-calendar-line"></i>
                查看更新节奏
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}